import React from 'react';
import { CookiePolicy } from '../../components/cookie-policy';

export const CookiePolicyPage: React.FC = () => <CookiePolicy />;
